import { IconCircleFilled } from '@tabler/icons-react'


const NotActiceCircle = () => {
  return (
    <div
      style={{
        display: 'flex',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'red',
        borderRadius: '50%',
        marginRight: '0.5rem',
      }}
    >
      <IconCircleFilled
        style={{
          borderWidth: '2px',
          borderStyle: 'solid',
          borderColor: '#fff',
          borderRadius: '100%',
        }}
        color='red'
        size={20}
      />
    </div>
  )
}

export default NotActiceCircle
